import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ReportGuard implements CanActivate, CanActivateChild {
    constructor(
        private router: Router,
        private notificationsService: NotificationsService,
        private translate: TranslateService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | boolean {
        if (route.queryParamMap.get('ruid')) {
            return true;
        } else {
            this.router.navigate(['/home']);
            this.notificationsService.warn(
                this.translate.instant('common.warning'),
                this.translate.instant('common.noReport')
            );
            return false;
        }
    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | boolean {
        return this.canActivate(route, state);
    }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/guards/reports.guard.ts